import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';
import { isRefiQualified } from '../../utils/app_data';

export const MinNumberPaymentsBeforeOnboardingStep: Step = {
  id: 'minNumberPayments',
  pathname: '/minnumberpayments',
  excludeFromProgressCalculation: true,

  canShow: (appData) => {
    if (appData.isFromMAL) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    // If insurance is selected, ask loan questions in the onboarding section
    if (appData.selectedService?.insurance) {
      return false;
    }

    /// Only show when refi service is selected and user is qualified
    return !!appData.selectedService?.refi && isRefiQualified(appData);
  },
  hasData: () => true,
  hasOwnData: (appData) => appData.signupParams?.hasMinNumberCarLoanPayments !== undefined,
  category: (appData) => (appData?.isSigned ? StepCategory.Other : StepCategory.Cars),
};
